import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-validate-password',
  templateUrl: './validate-password.component.html',
  styleUrls: ['./validate-password.component.scss']
})
export class ValidatePasswordComponent implements OnInit {

  @Input() password: string;
  @Input() confirm: string;
  @Output() passMatchEvent = new EventEmitter();
  passValidLength = false;
  passContainsNumber = false;
  passContainsLower = false;
  passContainsCapital = false;
  passMatch = false;
  public readonly imagePath = "assets/images/check_24px.svg"

  constructor() { }

  ngOnInit(): void {
  }

  validatePassword() {
    if (/\d/.test(this.password)) {
      this.passContainsNumber = true;
    } else {
      this.passContainsNumber = false;
    }

    const re = /.*[A-Z].*/;
    const lc = /.*[a-z].*/;

    if (re.test(this.password)) {
      this.passContainsCapital = true;
    } else {
      this.passContainsCapital = false;
    }

    if (lc.test(this.password)) {
      this.passContainsLower = true;
    } else {
      this.passContainsLower = false;
    }

    if (this.password.length >= 6) {
      this.passValidLength = true;
    } else {
      this.passValidLength = false;
    }
  }

  passwordMatches() {
    if (this.confirm === this.password && this.password !== '') {
      this.passMatch = true;
    } else {
      this.passMatch = false;
    }
    this.passMatchEvent.emit(this.passMatch);
  }

}
